import React from 'react';
import { useTranslation } from 'react-i18next';
import './sec6.css';
import BookingHero from '../common/headsec';
import sec6Img from '../../asserts/sec6-img.png';
import arrowIc from '../../asserts/ic.png';

const Sec6 = () => {
    const { t } = useTranslation();
    return (
        <>
            <section className='sec6'>
                <div className='sec6-container'>

                    <BookingHero
                        t1={t('sec6_hero_tag')}
                        t2={t('sec6_hero_t1')}
                        t3={t('sec6_hero_t2')}
                        text={t('sec6_hero_text')}
                    />

                    <div className='sec6-card'>

                        <div className='sec6-left'>
                            <img className='sec6-img' src={sec6Img} alt='Summer Music Festival' />
                        </div>

                        <div className='sec6-divider'></div>

                        <div className='sec6-right'>

                            <h2 className='sec6-title'>{t('sec6_title')}</h2>

                            <p className='sec6-text'>
                                {t('sec6_desc')}
                            </p>


                            <div className='sec6-tags'>
                                <span className='sec6-tag'>{t('sec3_cat_concerts')}</span>
                                <span className='sec6-tag'>Festival</span>
                                <span className='sec6-tag'>Outdoor</span>
                                <span className='sec6-tag'>Multi-Day</span>
                            </div>

                            <ul className='sec6-points'>
                                <li className='sec6-point'>
                                    <span className='sec6-dot'></span>
                                    {t('sec6_point1')}
                                </li>
                                <li className='sec6-point'>
                                    <span className='sec6-dot'></span>
                                    {t('sec6_point2')}
                                </li>
                                <li className='sec6-point'>
                                    <span className='sec6-dot'></span>
                                    {t('sec6_point3')}
                                </li>
                                <li className='sec6-point'>
                                    <span className='sec6-dot'></span>
                                    {t('sec6_point4')}
                                </li>
                                <li className='sec6-point'>
                                    <span className='sec6-dot'></span>
                                    {t('sec6_point5')}
                                </li>
                            </ul>

                            <div className='sec6-footer'>
                                <div className='sec6-price-wrap'>
                                    <span className='sec6-from'>{t('sec6_starting')}</span>
                                    <span className='sec6-price'>$249</span>
                                </div>
                                <button className='sec6btn'>
                                    {t('sec6_btn')}
                                    <img className='btn1ic' src={arrowIc} alt='arrow' />
                                </button>
                            </div>

                        </div>
                    </div>

                </div>
            </section>
        </>
    );
};

export default Sec6;